
































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { BFormDatepicker } from "bootstrap-vue";
import { ScheduleLogEntry } from "@/store/modules/types";
import { ScheduleLogType } from "@/store/modules/enums";
import { VueEditor } from "vue2-editor";
import ModalHeader from "../ModalHeader.vue";

@Component({
  components: {
    ModalHeader,
    VueEditor,
    BFormDatepicker,
  },
})
export default class Log extends Vue {
  @Prop() readonly calendar: any;
  /*   @Prop() readonly embedded?: boolean;
  @Prop() readonly showComment?: boolean; */
  calendarSlotBlock: any = {
    type: "d",
    dateFrom: null,
    dateTo: null,
    timeFrom: null,
    timeTo: null,
    days: [],
  };

  calendarBlockedHours: any = [];
  calendarConfigs: any = [];
  deletedConfigs: any = [];

  daysWeek = [
    {
      id: "SUN",
      name: "Sun",
      checked: false,
    },
    {
      id: "MON",
      name: "Mo",
      checked: false,
    },
    {
      id: "TUE",
      name: "Tu",
      checked: false,
    },
    {
      id: "WED",
      name: "We",
      checked: false,
    },
    {
      id: "THU",
      name: "Th",
      checked: false,
    },
    {
      id: "FRI",
      name: "Fr",
      checked: false,
    },
    {
      id: "SAT",
      name: "Sa",
      checked: false,
    },
  ];

  log: Array<any> = [];
  comment = "";
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  async getCalendarConfig() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      this.calendarConfigs = await this.$store.dispatch(
        "schedule/getCalendarConfig",
        this.calendar.id
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async save() {


    var configObj: any = {
      date: null,
      sessionId: null,
      weekDay: null,
      startTime: null,
      endTime: null,
      timeApptLimit: 0,
      sessionApptLimit: 0,
      disabled: 1,
    };

    var config: any = [];

    for (let i = 0; i < this.calendarBlockedHours.length; i++) {
      var dateFrom: any =
        this.calendarBlockedHours[i].dateFrom != null
          ? this.$moment(this.calendarBlockedHours[i].dateFrom)
          : null;
      var dateTo =
        this.calendarBlockedHours[i].dateTo != null
          ? this.$moment(this.calendarBlockedHours[i].dateTo)
          : null;
      var startTime =
        this.calendarBlockedHours[i].timeFrom != null
          ? this.calendarBlockedHours[i].timeFrom
          : "12:00 AM";
      var endTime =
        this.calendarBlockedHours[i].timeTo != null
          ? this.calendarBlockedHours[i].timeTo
          : "11:50 PM";

      if (dateFrom == null && dateTo != null) {
        dateFrom = this.$moment();
      }

      if (dateFrom != null && dateTo == null) {
        dateTo = dateFrom;
      }

      if (dateFrom != null && dateTo != null) {
        while (dateFrom.isSameOrBefore(dateTo)) {
          // if (this.daysWeek.filter(d => d.name == dateFrom.format("dd") && d.checked).length > 0) {
          if (this.daysCheked.length == 0) {
            configObj.date = dateFrom.format("YYYY-MM-DD");
            configObj.weekDay = dateFrom.format("ddd").toUpperCase();
            configObj.sessionId = this.getSession(startTime, endTime);
            configObj.startTime = startTime;
            configObj.endTime = endTime;
            config.push(Object.assign({}, configObj));
          } else if (
            this.daysCheked.filter(
              (d) => d.id == dateFrom.format("ddd").toUpperCase()
            ).length > 0
          ) {
            configObj.date = dateFrom.format("YYYY-MM-DD");
            configObj.weekDay = dateFrom.format("ddd").toUpperCase();
            configObj.sessionId = this.getSession(startTime, endTime);
            configObj.startTime = startTime;
            configObj.endTime = endTime;
            config.push(Object.assign({},configObj));
          }

          dateFrom.add(1, "days");
        }
      } else {
        for (var x in this.calendarBlockedHours[i].days) {
          configObj.date = "1900-01-01";
          configObj.weekDay =
            this.calendarBlockedHours[i].days[x].id.toUpperCase();
          configObj.sessionId = this.getSession(startTime, endTime);
          configObj.startTime = startTime;
          configObj.endTime = endTime;
          config.push(Object.assign({},configObj));
        }
      }
    }

    //

    this.$store.commit("main/SET_LOADING", true);
    try {
      const calendar = {
        calendarId: this.calendar.id,
        config: config,
        deleteConfig: this.deletedConfigs,
      };
      await this.$store.dispatch("schedule/saveCalendarConfig", calendar);
    } catch (error) {
      console.log(error);
    } finally {
        this.close();
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async markRead(log) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/markLogRead", log.id);
      this.getCalendarConfig();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  get unreadComments() {
    return this.log.filter((row) => {
      return (
        !row.isRead &&
        (row.typeId === ScheduleLogType.PATIENT_COMMENT ||
          row.typeId === ScheduleLogType.DRIVER_COMMENT)
      );
    });
  }

  getSession(startTime, endTime) {
    var startHour = parseInt(this.$moment(startTime, "h:mm A").format("HH"));
    var endHour = parseInt(this.$moment(endTime, "h:mm A").format("HH"));

    if (startHour >= 6 && endHour <= 12) {
      return "MN";
    }

    if (startHour >= 12 && endHour <= 14) {
      return "NN";
    }

    if (startHour >= 14 && endHour <= 18) {
      return "AN";
    }

    if (startHour >= 18 && endHour <= 0) {
      return "NT";
    }

    return "XX";
  }

  get times() {
    var times: any = [];
    var periods: any = ["AM", "PM"];
    var hours: any = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    var prop: any = null;
    var hour: any = null;
    var min: any = null;

    for (prop in periods) {
      for (hour in hours) {
        for (min = 0; min < 60; min += 10) {
          const time =
            ("0" + hours[hour]).slice(-2) +
            ":" +
            ("0" + min).slice(-2) +
            " " +
            periods[prop];
          times.push(time);
        }
      }
    }

    return times;
  }

  get horary() {
    return this.calendarConfigs.filter((c) => c.disabled == "0");
  }

  get disabledHorary() {
    return this.calendarConfigs.filter((c) => c.disabled == "1");
  }

  get daysCheked() {
    return this.daysWeek.filter((d) => d.checked);
  }

  addHourBloked() {
    if (
      this.calendarSlotBlock.dateFrom != null ||
      this.calendarSlotBlock.dateTo != null ||
      this.calendarSlotBlock.timeFrom != null ||
      this.calendarSlotBlock.timeTo != null ||
      this.calendarSlotBlock.dateTo != null ||
      this.daysCheked.length > 0
    ) {
      this.calendarSlotBlock.days = this.daysWeek.filter((b) => b.checked);
      this.calendarBlockedHours.push(Object.assign({}, this.calendarSlotBlock));
    }
  }

  deleteBlockedHours(index) {
    if (index != null) {
      this.calendarBlockedHours.splice(index, 1);
    } else {
      this.calendarBlockedHours = [];
    }
  }

  deleteTimeConfig(config) {
                    this.deletedConfigs.push(Object.assign({},config));
                    var index = this.calendarConfigs.indexOf(config);
                    this.calendarConfigs.splice(index, 1);
                }

  close() {
    this.$modal.hide("calendar-editor");
    this.$emit("closed");
  }

  mounted() {
    this.getCalendarConfig();
  }
}
